import { Link } from "react-router-dom";
import { useApi, Card, Loading, StatusBadge, PageHeader, Empty } from "../components/common";
import { fdate, inr } from "../lib/format";

const Group = ({ title, items, tone, testid }) => (
  <Card title={`${title} (${items.length})`} testid={testid}>
    {items.length ? items.map((l) => (
      <Link key={l.id} to={`/leads/${l.id}`} data-testid={`followup-${l.id}`} className="flex items-center justify-between gap-3 py-2.5 border-b last:border-0 hover:bg-violet-50/50 -mx-2 px-2 rounded">
        <div className="min-w-0"><div className="text-sm font-medium truncate">{l.client_name} <span className="text-xs text-muted-foreground">· {l.studio_name}</span></div>
          <div className="text-xs text-muted-foreground">{l.phone} · {inr(l.est_value)}</div></div>
        <div className="text-right shrink-0"><div className={`text-xs font-semibold ${tone}`}>{fdate(l.next_followup)}</div><StatusBadge value={l.status} /></div>
      </Link>
    )) : <Empty text="None" />}
  </Card>
);

export const FollowUpList = ({ data }) => (
  <div className="grid lg:grid-cols-3 gap-4" data-testid="followup-dashboard">
    <Group testid="followups-overdue" title="Overdue" items={data.overdue} tone="text-rose-600" />
    <Group testid="followups-today" title="Due Today" items={data.today} tone="text-amber-600" />
    <Group testid="followups-upcoming" title="Upcoming" items={data.upcoming} tone="text-violet-600" />
    {data.without_followup > 0 && <p className="text-xs text-muted-foreground lg:col-span-3">{data.without_followup} open leads have no follow-up scheduled.</p>}
  </div>
);

export default function FollowUps() {
  const { data, loading } = useApi("/followups");
  return (
    <div>
      <PageHeader title="Follow-ups" subtitle="Scheduled lead follow-ups by due date (IST)" />
      {loading || !data ? <Loading /> : <FollowUpList data={data} />}
    </div>
  );
}
